var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgAzureOriginal = function SvgAzureOriginal(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_AzureOriginal__paint0_linear_19_30052)",
    d: "M6.683.63h5.911L6.458 18.812a.94.94 0 0 1-.894.64h-4.6a.94.94 0 0 1-.892-1.241L5.79 1.27A.94.94 0 0 1 6.683.63"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0078D4",
    d: "M15.273 12.825H5.899a.434.434 0 0 0-.296.751l6.023 5.622a.95.95 0 0 0 .646.255h5.308z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_AzureOriginal__paint1_linear_19_30052)",
    d: "M6.683.63a.935.935 0 0 0-.895.653L.079 18.195a.94.94 0 0 0 .888 1.258h4.719a1.01 1.01 0 0 0 .774-.659l1.138-3.354 4.067 3.792c.17.141.384.22.605.22h5.288l-2.32-6.627-6.76.002L12.615.63z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_AzureOriginal__paint2_linear_19_30052)",
    d: "M14.233 1.27a.94.94 0 0 0-.892-.64H6.753a.94.94 0 0 1 .892.64l5.718 16.94a.94.94 0 0 1-.892 1.243h6.588a.94.94 0 0 0 .892-1.242z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_icon_AzureOriginal__paint0_linear_19_30052",
    x1: 8.837,
    x2: 2.698,
    y1: 2.024,
    y2: 20.161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#114a8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0669bc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_icon_AzureOriginal__paint1_linear_19_30052",
    x1: 10.755,
    x2: 9.335,
    y1: 10.477,
    y2: 10.957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.321,
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623,
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_icon_AzureOriginal__paint2_linear_19_30052",
    x1: 9.974,
    x2: 16.713,
    y1: 1.495,
    y2: 19.449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3ccbf4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2892df"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAzureOriginal);
export { ForwardRef as ReactComponent };